import styled, { css } from "styled-components";
import { Field as FormikField } from "formik";

import { transition } from "@ui/helpers";
import { Arrow } from "@ui/Assets/MyIcons";
import { Text } from "@ui/Atoms";

import { StyledActive, ListProps } from "./Select.types";

export const Root = styled.fieldset<StyledActive>`
  all: unset;

  position: relative;
  min-width: 180px;
  max-width: 100%;
  z-index: 1;

  ${props =>
    props.$isActive &&
    css`
      z-index: 2;
    `}
`;

export const NativeField = styled(FormikField)`
  all: unset;

  position: absolute;
  inset: 0;
  z-index: 2;
  opacity: 0;

  ${props => props.theme.breakpointsV2.smallTablet} {
    display: none;
  }
`;

export const List = styled.ul<ListProps>`
  position: absolute;
  left: 0;
  max-height: 400px;
  min-width: max(225px, 100%);
  width: calc(100% + ${props => props.theme.spacing.spacing_24});
  margin: 0;
  padding: ${({ theme }) =>
    `${theme.spacing.spacing_16} ${theme.spacing.spacing_24}`};
  border-radius: 8px;
  background-color: ${props => props.theme.palette.white};
  transition: ${transition(["transform", "opacity"])};
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.spacing_24};
  opacity: 0;
  overflow: auto;
  overscroll-behavior: contain;
  pointer-events: none;
  z-index: 0;

  ${props =>
    props.$position === "top" &&
    css`
      bottom: calc(100% + ${props => props.theme.spacing.spacing_4});
      transform: translateY(16px);
    `}

  ${props =>
    props.$position === "bottom" &&
    css`
      top: calc(100% + ${props => props.theme.spacing.spacing_4});
      transform: translateY(-16px);
    `}

  ${props =>
    props.$isActive &&
    css`
      transform: translateY(0);
      opacity: 1;
      pointer-events: all;
    `}

  ${props => props.theme.breakpointsV2.smallDesktop} {
    width: 300px;
  }

  @media (max-height: 800px) {
    max-height: 200px;
  }
`;

export const Icon = styled(Arrow).attrs(props => ({
  width: props.theme.icons.sizes.base_x3,
  color: props.theme.palette.grey200,
}))<StyledActive>`
  transform: rotate(90deg);
  transition: ${transition(["transform"])};

  ${props =>
    props.$isActive &&
    css`
      transform: rotate(-90deg);
    `}
`;

export const Label = styled.span`
  position: relative;
  overflow: hidden;
`;

export const LongestLabel = styled.div`
  padding-right: ${props => props.theme.spacing.spacing_12};
  opacity: 0;
  display: inline;
  pointer-events: none;
  user-select: none;
  white-space: nowrap;
`;

export const ActiveLabel = styled.span`
  position: absolute;
  inset: 0;
  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const ErrorMessage = styled(Text).attrs({
  as: "span",
  $style: "regular_12",
  $color: "red500",
})`
  position: relative;
  display: block;
  height: 0px;
  margin-top: 2px;
  margin-bottom: 4px;
  left: ${props => props.theme.spacing.spacing_16};
  top: 0px;

  ${({ theme }) => theme.breakpointsV2.smallTablet} {
    margin: 0;
    top: 2px;
  }
`;
